import React, { useState, useEffect } from 'react';
import { IconButton, Popover, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import JobDetailsCCModal from '../jobDetailsCCModal';
import { parseToEasternTime } from '../../utils/dates';
import { useNotification } from '../../context/NotificationContext';
import { createErrorMessage } from '../../utils';

export default function BaseDecryptCreditCardPopover({ creditCardId, useQueryHook, tooltipText = "View details for selected Credit Card", onDecryptError }) {
  const { showNotification } = useNotification();
  const [anchorEl, setAnchorEl] = useState(null);
  const [CCinfo, setCCinfo] = useState(null);
  const [CCinfoViewHistory, setCCinfoViewHistory] = useState(null);
  const [loading, setLoading] = useState(false);

  const [getCreditPrivateDataFromApi] = useQueryHook();

  const open = Boolean(anchorEl);

  async function fetchCCPrivateInfo(id) {
    try {
      setLoading(true);
      setCCinfo(null);
      setCCinfoViewHistory(null);

      const { response } = await getCreditPrivateDataFromApi(id).unwrap();
      if (response) {
        setCCinfoViewHistory({
          userName: response.lastViewedBy || '-',
          date: response.lastViewedOn ?  parseToEasternTime(response.lastViewedOn + "Z") : '-',
        });

        setCCinfo({
          cardBrand: response.cardBrand,
          cardNumber: response.number,
          expirMonth: response.expirMonth,
          expirYear: response.expirYear,
          cvvCode: response.cvv,
          additionalCode: response.additionalCode,
        });
      }
    } catch (error) {
      console.log(error);
      showNotification(createErrorMessage(error), 'error');
      handleClose();
      if(onDecryptError) onDecryptError();
    } finally {
      setLoading(false);
    }
  }

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCCinfo(null);
    setCCinfoViewHistory(null);
    setLoading(false);
  };

  useEffect(() => {
    if (open && creditCardId) {
      fetchCCPrivateInfo(creditCardId);
    }
  }, [open, creditCardId]);

  let content;
  if (!creditCardId) {
    content = <p style={{ margin: "0.5rem" }}>Please select a Credit Card.</p>;
  } else if (loading) {
    content = <p style={{ margin: "0.5rem" }}>Waiting data...</p>;
  } else if (CCinfo && CCinfoViewHistory) {
    content = <JobDetailsCCModal CCinfo={CCinfo} history={CCinfoViewHistory} />;
  } else {
    content = <p style={{ margin: "0.5rem" }}>Waiting data...</p>;
  }

  return (
    <>
      <Tooltip title={tooltipText} placement="top-start">
        <IconButton
          sx={{ margin: '0 0 0 4px', width: 28, height: 28 }}
          onClick={handleOpen}
        >
          <InfoOutlinedIcon sx={{ height: '20px' }} color="primary" alt="CC detail info" />
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {content}
      </Popover>
    </>
  );
}
